<div class="true-modal-container">
    <h1>Step completed</h1>
    <mat-dialog-content>
        <p>
            You've entered all the required information for this step. You can now proceed to the next step of the assessment or review your inputs before continuing.
        </p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <div class="simple">            
            <button title="Review this step" class="cancel">
                <mat-icon (click)="close()">close</mat-icon>
              </button>              
              <button title="Continue to next step" class="next" (click)="next()">
                <mat-icon>arrow_forward</mat-icon>
              </button>
        </div>        
    </mat-dialog-actions>
</div>